<template>
  <span class="notification-outcome">
    <el-tag size="mini" effect="plain" :type="state.tagType">{{ state.text }}</el-tag>
    <span v-if="showHelp && state.help" class="help">{{ state.help }}</span>
  </span>
</template>

<script>
export default {
  name: 'NotificationOutcomeTag',
  props: {
    run: { type: Object, default: () => ({}) },
    notifications: { type: Array, default: () => [] },
    showHelp: { type: Boolean, default: false }
  },
  computed: {
    state() {
      const run = this.run || {}
      if (!Object.keys(run).length) return { text: '尚无记录', tagType: 'info', help: '' }

      const runStatus = String(run.status || run.child_status || '').toLowerCase()
      const disposition = String(run.notification_disposition || '').toLowerCase()
      if (
        run.group_id === 'position_context_watch' &&
        (runStatus === 'pending_first_run' || disposition === 'awaiting_first_run')
      ) {
        return {
          text: '尚未发送',
          tagType: 'info',
          help: '任务已启用，等待首次计划运行；未到运行时间不会发送飞书。'
        }
      }

      const runId = String(run.parent_run_id || run.run_id || run.task_run_id || '').trim()
      const log = runId
        ? this.notifications.find(item => this.identifier(item) === runId)
        : null
      if (log) {
        const status = String(log.status || '').toLowerCase()
        if (['success', 'sent', 'delivered'].includes(status)) {
          return { text: '已发送', tagType: 'success', help: '飞书发送记录已确认。' }
        }
        if (status === 'failed') {
          return { text: '发送失败', tagType: 'danger', help: '任务结果已保留，请查看通知发送记录。' }
        }
        return { text: '发送状态待确认', tagType: 'warning', help: '已生成通知记录，送达状态仍待确认。' }
      }

      if (['no_new_no_send', 'risk_unchanged_no_send', 'normal_no_send', 'no_change_no_send'].includes(disposition)) {
        return {
          text: run.notification_disposition_text || '无需发送',
          tagType: 'info',
          help: run.group_id === 'position_context_watch'
            ? '风险状态没有变化，系统按降噪策略不重复发送飞书。'
            : '任务正常完成，没有新增内容，系统按降噪策略不发送飞书。'
        }
      }
      if (disposition === 'error_send_required') {
        return { text: '异常通知待确认', tagType: 'warning', help: '任务出现异常，请确认异常通知是否送达。' }
      }
      if (['new_items_send_required', 'send_required', 'risk_change_send_required'].includes(disposition)) {
        return { text: '发送记录待确认', tagType: 'warning', help: '本轮应发送通知，请到通知发送记录确认送达状态。' }
      }
      if (disposition === 'pending') {
        return { text: '任务结束后判断', tagType: 'info', help: '任务尚未结束。' }
      }

      const added = Number(run.new_items_count)
      const eventGroup = ['market_event_watch', 'stock_event_watch'].includes(run.group_id)
      if (runStatus === 'success' && eventGroup && Number.isFinite(added) && added === 0) {
        return {
          text: '无需发送（本轮无新增）',
          tagType: 'info',
          help: '任务正常完成，没有新增内容，系统按降噪策略不发送飞书。'
        }
      }
      if (runStatus === 'success') {
        return { text: '发送记录待确认', tagType: 'warning', help: '请到通知发送记录确认送达状态。' }
      }
      if (['failed', 'partial_success'].includes(runStatus)) {
        return { text: '异常通知待确认', tagType: 'warning', help: '任务出现异常，请确认异常通知是否送达。' }
      }
      if (['running', 'pending'].includes(runStatus)) {
        return { text: '任务结束后判断', tagType: 'info', help: '任务尚未结束。' }
      }
      return { text: '状态待确认', tagType: 'info', help: '' }
    }
  },
  methods: {
    identifier(row) {
      return String(row && (row.title || row.parent_run_id || row.task_run_id || row.run_id || row.batch_log_id) || '').trim()
    }
  }
}
</script>

<style scoped>
.notification-outcome { display: inline-flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.help { color: #64748b; font-size: 12px; line-height: 1.5; }
</style>
